export { default } from "./MapAddress-component";
